export const EQUITY_BUY_TYPES = [
  "BUY",
  "DIVIDEND_PAYOUT",
  "DIVIDEND_REINVEST",
  "TRANSFERRED_IN",
  "BONUS",
  "DEMERGER",
  "DEMERGER_NEW",
  "IPO",
  "MERGER",
  "SPLIT",
] as const;

export const EQUITY_SELL_TYPES = [
  "SELL",
  "REDEEM",
  "BUYBACK",
  "WRITEOFF",
  "TRANSFERRED_OUT",
] as const;

export const equityTxKey = (type?: string | null) =>
  String(type ?? "")
    .trim()
    .replace(/[()]/g, "")
    .replace(/\s+/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "")
    .toUpperCase();

export const isEquityBuyType = (type?: string | null): boolean => {
  const key = equityTxKey(type);
  return (
    (EQUITY_BUY_TYPES as readonly string[]).includes(key) || key === "PURCHASE"
  );
};

export const isEquitySellType = (type?: string | null): boolean => {
  const key = equityTxKey(type);
  return (
    (EQUITY_SELL_TYPES as readonly string[]).includes(key) ||
    key === "REDEMPTION"
  );
};
